export default __webpack_public_path__ + "static/media/ProgrammerTonic.b9b9caeefe59262206b8405fd7fef75c.webp";